import { Body } from '@optimus-web/core';
import { TextKey, RouteName } from '@mews-commander/enums';
import { WithOwnerId } from '@mews-commander/types';
import { useResolveRoute } from '@mews/routing';
import { SidePanelInfoRowItem } from '../SidePanelInfoRowItem';
import { ModalLink } from '../../../../components';

interface OwnProps extends Partial<WithOwnerId> {
    isCompany: boolean;
    ownerName?: string | null;
}

export const CorrectionBillCustomerInfo = ({ ownerId, ownerName, isCompany }: OwnProps) => {
    const resolveRoute = useResolveRoute();

    if (!ownerId || !ownerName) return null;

    const url = resolveRoute(isCompany ? RouteName.CompanyDetail : RouteName.CustomerDetail, { id: ownerId });

    return (
        <SidePanelInfoRowItem
            rowLabelTextKey={TextKey.Customer}
            rowInfo={
                <Body>
                    <ModalLink
                        url={url}
                        {...(isCompany
                            ? { 'data-test-customer-link': ownerId }
                            : { 'data-test-company-link': ownerId })}
                    >
                        {ownerName}
                    </ModalLink>
                </Body>
            }
        />
    );
};
